import { TRootState } from 'Redux/Reducers';

export const getInsuranceCooperationErrorCode = (state: TRootState) => state.insuranceCooperation.errorCode;
